import { useCallback } from 'react';

import {
  type FieldActionsContextValue,
  useFieldActions,
} from '../../contexts/field-actions-context';
import { type IUploadFileFieldAction } from '../../services/upload-file';
import { type WixFile } from '../form/types';

export const useUploadSignature = (uploadTarget: string) => {
  const { actions, formId } =
    useFieldActions() as FieldActionsContextValue<IUploadFileFieldAction>;

  const uploadFile = actions?.uploadFile;

  return useCallback(
    async (file: File): Promise<WixFile> => {
      if (!uploadFile) {
        throw new Error('No uploadFile action');
      }
      const fileDescriptor = await uploadFile({
        file,
        formId,
        uploadTarget,
      });
      const { id, displayName, url, isPrivate } = fileDescriptor!;
      return {
        fileId: id,
        displayName: displayName || file.name,
        url: !isPrivate ? url : undefined,
        fileType: file.type,
      } as WixFile;
    },
    [uploadFile, formId, uploadTarget],
  );
};
